import React from 'react';

export default function GlobalDisputeResolutionPolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          Global Dispute Resolution Policy
        </h1>

        <p className="text-gray-700 mb-8">
          This policy governs how financial disputes, service disagreements, and cross-border conflicts will be handled inside Million2Trillion (M2T).
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Internal Dispute System</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>M2T operates a fully documented internal dispute system for platform members.</li>
          <li>Both service providers and buyers may file official complaints via the user dashboard.</li>
          <li>M2T will investigate each case using transaction data, content history, and verified communication logs.</li>
          <li>Temporary fund holds or suspensions may occur during dispute investigation periods.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Binding Arbitration Model</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All verified users agree that platform-level financial disputes will first attempt resolution via internal arbitration conducted by M2T’s compliance team.</li>
          <li>Both parties may submit supporting documents, evidence, and legal statements for platform review.</li>
          <li>M2T’s arbitration decision will be final unless extreme legal violations exist (fraud, criminal misconduct, or third-party jurisdiction breach).</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Cross-Border Jurisdiction Handling</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>M2T operates internationally; all verified members agree to global jurisdiction neutrality for financial transactions handled inside the platform.</li>
          <li>Cross-border legal conflicts will follow the core governing laws of M2T’s registered operating headquarters (UAE, United States).</li>
          <li>International law firms or authorized mediators may be appointed when applicable for high-value financial claims.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Protection of Verified Market Integrity</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>M2T reserves full rights to immediately suspend or terminate accounts proven to abuse dispute filing rights or attempt fraud through legal threats.</li>
          <li>Verified trust remains the highest priority; all disputes will be handled with neutrality, documented transparency, and platform-wide consistency.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          Verified marketplaces require verified dispute handling. Fair, neutral, and transparent arbitration protects every verified financial professional on M2T.
        </p>
      </div>
    </div>
  );
}
